import { Navigate } from '@sorare/routing';

import { ANY_SPORT_MARKET_COMMON_PACKS } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import { BuyGemsDialog } from '@sorare/marketplace/src/components/commonCard/BuyGemsDialog';

const BuyGemsPage = () => {
  const {
    canOpenCartOpenPaymentBoxAndCloseCurrentWebview: canCloseCurrentWebview,
    postMessage,
  } = useIsMobileApp();
  const { generateSportContextPath } = useSportContext();
  if (!canCloseCurrentWebview) {
    return (
      <Navigate to={generateSportContextPath(ANY_SPORT_MARKET_COMMON_PACKS)} />
    );
  }
  return (
    <BuyGemsDialog
      onClose={() => {
        postMessage('closeCurrentWebview');
      }}
    />
  );
};

export default BuyGemsPage;
